import { getWeb3InfraGlobalConfig } from '../store/config';
import { userWalletStore } from '../store/userWallet';
import { thirdPartyWallet } from '../wallet-hub/Web3WalletHubCenter';
import { BybitExtensionHub, hasBybitExtension } from '../wallet-hub/hubs/BybitExtensionHub';
import { ScTrackFn } from './common';
import { walletIdMap } from './constants';
import { infraVersion, isBrowser } from './trick';

export const scTrack: ScTrackFn = async (event, data = {}) => {
  if (!isBrowser) {
    return;
  }
  const sensors = window['sensors'] || window['sensorsDataAnalytic201505'];
  if (!sensors) {
    return;
  }

  const { isCloudWallet, isNone, evmAddress } = userWalletStore.state;
  sensors.track(event, {
    wallet_chain_type: 'evm',
    wallet_type: isNone ? 0 : isCloudWallet ? 1 : 7,
    wallet_sourcename: thirdPartyWallet.activeWalletHub?.name ?? '',
    evm_wallet_address: evmAddress,
    is_install_bybit_wallet: hasBybitExtension(),
    web3sdk_version: infraVersion,
    dapp_name: getWeb3InfraGlobalConfig().appName,
    ...data,
  });
};

if (isBrowser) {
  thirdPartyWallet.on('connectFailed', (hub, err) => {
    scTrack('Web3userClick', {
      page_name: 'web3sdkConnect',
      wallet_sourcename: hub.name,
      connect_status: 'failed',
      evm_wallet_address: '',
      wallet_type: 7,
      connect_message: typeof err === 'string' ? err : (err as any).message ?? '',
    });
  });
  thirdPartyWallet.on('switchSuccess', (hub, isRecovery) => {
    scTrack('Web3userClick', {
      page_name: 'web3sdkConnect',
      wallet_sourcename: hub.name,
      connect_status: 'success',
      connect_message: '',
      isRecovery,
      wallet_type: hub.id === walletIdMap.bybit && (hub as BybitExtensionHub).isBybitCloud ? 1 : 7,
      evm_wallet_address: hub.EVM?.address ?? '',
    });
  });
}
